var _rule = require("../rule.js");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _rule2.default.makeRule({
    name: "blockquoted-math",
    severity: _rule2.default.Severity.WARNING,
    selector: "blockQuote math, blockQuote blockMath",
    message: "Blockquoted math:\nmath should not be indented."
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/gorgon/rules/blockquoted-math.js
 ** module id = 210
 ** module chunks = 0 2
 **/